import { Button, Icon, Typography } from '@modulor/react';
import { useSkeletonTranslation } from 'hooks/useSkeletonTranslation';
import type { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { selectedCardSelector, showDeleteCardMode } from 'store/slices/userCard';

import { getWidgetLocation } from '../../../utils';

export const CardsActionButton: FC = () => {
  const { pathname } = useLocation();
  const { isCards } = getWidgetLocation(pathname);
  const { isDeleteCardMode } = useAppSelector(selectedCardSelector);
  const dispatch = useAppDispatch();
  const { skeletonT } = useSkeletonTranslation();

  if (!isCards) {
    return null;
  }

  return isDeleteCardMode ? (
    <Button variant="text_button" onClick={() => dispatch(showDeleteCardMode(false))}>
      <Typography variant="body-semibold" className="aggree-button">
        {skeletonT('PH.BUTTON.DONE')}
      </Typography>
    </Button>
  ) : (
    <Button variant="text_button" onClick={() => dispatch(showDeleteCardMode(true))}>
      <Icon name="delete_outlined" fill="text-error" />
    </Button>
  );
};
